module.exports = __webpack_public_path__ + "media/images/amenities_icons/wifi-6fa094756f5ed2c614837650ea6bb1b8.svg";